import { getTranslations } from '@onlinepayments/payments-library';

import { getLanguageCode } from './localization';

export default function getDayjsLocale(): ILocale {
  const translations = getTranslations().dayjs;

  return {
    weekdays: [],
    name: getLanguageCode(),
    months: translations.months?.split(',').map((month: string) => month.trim()),
    weekdaysMin: translations.weekdaysMin?.split(',').map((day: string) => day.trim()),
    weekdaysShort: translations.weekdaysShort?.split(',').map((day: string) => day.trim()),
    formats: {},
    relativeTime: {},
  };
}
